import React, { Component } from 'react';
import './steps.css'
import moment from "moment"

class Steps extends Component {
    render(){
        const {data} = this.props
        console.log(data)
        return(
            <div className="steps-container">
                {data.map((step, index) => {
                let color = "black";
                if(step.status === "FINISHED"){
                    color = "green"
                }
                if(step.status === "CURRENT"){
                    color = "black"
                }
                if(step.status === "PLANNED"){
                    color = "gray"
                }
                return (
                    <React.Fragment>
                        <div className="steps-item">
                        <p style={{
                            "margin-top": "5px",
                            "font-weight":"bold",
                            color: color
                        }}>
                            {step.do_number} ({step.status})<br />
                            Routes : {step.workOrders.map(wo => wo.sp_name).toString().replaceAll(","," - ")} <br />
                            Est. Start : {moment(step.assigned_do_date).format("YYYY-MM-DD HH:mm:ss")}
                        </p>
                        <p
                            style={{
                                "margin-top": "-10px",
                                color: color
                            }}
                        >
                            Driver : {step.driver_name} <br />
                            Driver Assistant  : {step.driver_assistant_name} <br />
                            Transporter : {step.company} <br />
                            Shipper : {this.props.shipper} <br />
                            Fleet ID : {step.fleet_plate} <br />
                         </p>
                        </div>
                    </React.Fragment>
                );
                })}
            </div>
        )
    }

} export default Steps


// WEBPACK FOOTER //
// ./src/views/Transporter/TrackAndTraceTracker/VerticalTimeline/Steps/index.jsx